import { Component, Input } from '@angular/core';

@Component({
    selector: 'services-and-fares-edit',
    templateUrl: './services-and-fares-edit.component.html',
    styleUrls: ['./services-and-fares-edit.component.scss']
})
export class ServicesAndFaresEditComponent {
    @Input()
    public serviceType: number = 0;

    @Input()
    public showPopup: boolean = false;

    @Input()
    public onHide: () => void = () => { };

    public handleSideBarHide() {
        this.onHide();
    }
}
